module.exports = __webpack_public_path__ + "img/imgs1.349876f3.png";